import slidedata from '@/view/map/hdmconfigv2/slidedata';
import headertop from '@/view/map/hdmconfigv2/header';
import mapv2assembly from '@/view/map/hdmconfigv2/map';
import cdata from './common.js';
export default {
  name: 'mapconfigv2',
  components: {
    headertop,
    slidedata,
    mapv2assembly
  },
  meta: {
    title: '地图配置页'
  },
  data() {
    return {
      leftSlideArr: [],
      leftIndex: 0
    };
  },
  mounted() {
    this.leftSlideArr = cdata.MenuData;
  },
  watch: {},
  methods: {
    switchSlide(index) {
      this.leftIndex = index;
    }
  }
};